export const isValidPassword = password =>
  !(
    password.length < 8 ||
    !(
      password.match(/[A-Z]/) &&
      password.match(/[a-z]/) &&
      password.match(/[~\!@#\$%\^&*\(\)_\-\+=\|\}\]\{\[:;"',\.\?\/<>\`\\]/)
    )
  );

/* prettier-ignore */
// prettier seems to be stripping \s from my strings
// TODO https://tickets.ingramcontent.com/browse/BO-3474
// vst-models: /\A([^@\s]+)@((?:[-_a-z0-9]+\.)+[a-z]{2,})\Z/i;
// old-reg: /^([^@\s]+)@((?:[-_a-z0-9]+\.)+[a-z]{2,})$/
export const emailPattern = "^([^@\\s]+)@((?:[-_a-z0-9]+\\.)+[a-z]{2,})$";
